import { Environment } from "../utils/environment";

export type Feature =
  | "IS_RESERVATIONS_ENABLED"
  | "IS_RESERVATIONS_CONVERSION_ENABLED"
  | "IS_OVERLAPPING_CONTRACT_ENABLED"
  | "IS_RESERVATIONS_NEXTGEN_BANNER_ENABLED"
  | "MULTI_INVOICE_PAY"
  | "IS_AUTO_PAY_SCHEDULE_PAY_ENABLED"
  | "SEE_AND_APPLY_CREDITS"
  | "ONLINE_DISCOUNT"
  | "IS_NEW_LOGIN_API_ENABLED"
  | "IS_SITE_OUTAGE_BANNER_ENABLED"
  | "IS_CUSTOMER_ACCESS_ENABLED"
  | "IS_DELEGATE_ACCESS_ENABLED";

export const FEATURE_FLAGS: Record<Feature, Record<Environment, boolean>> = {
  IS_RESERVATIONS_ENABLED: {
    dev: true,
    uat: true,
    preview: true,
    prod: true
  },
  IS_RESERVATIONS_CONVERSION_ENABLED: {
    dev: false,
    uat: false,
    preview: false,
    prod: false
  },
  IS_OVERLAPPING_CONTRACT_ENABLED: {
    dev: true,
    uat: true,
    preview: false,
    prod: false
  },
  MULTI_INVOICE_PAY: {
    dev: true,
    uat: false,
    preview: false,
    prod: false
  },
  IS_AUTO_PAY_SCHEDULE_PAY_ENABLED: {
    dev: true,
    uat: false,
    preview: false,
    prod: false
  },
  SEE_AND_APPLY_CREDITS: {
    dev: true,
    uat: true,
    preview: true,
    prod: true
  },
  ONLINE_DISCOUNT: {
    dev: true,
    uat: false,
    preview: false,
    prod: false
  },
  IS_RESERVATIONS_NEXTGEN_BANNER_ENABLED: {
    dev: true,
    uat: true,
    preview: true,
    prod: true
  },
  IS_NEW_LOGIN_API_ENABLED: {
    dev: true,
    uat: true,
    preview: false,
    prod: false
  },
  IS_CUSTOMER_ACCESS_ENABLED: {
    dev: true,
    uat: false,
    preview: false,
    prod: false
  },
  IS_SITE_OUTAGE_BANNER_ENABLED: {
    dev: false,
    uat: false,
    preview: false,
    prod: false
  },
  IS_DELEGATE_ACCESS_ENABLED: {
    dev: true,
    uat: false,
    preview: false,
    prod: false
  }
};
